var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumnentPlacholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.377,
    height: 17.471,
    viewBox: "0 0 14.377 17.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#180058;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.962,3H7.547A1.547,1.547,0,0,0,6,4.547V16.924a1.547,1.547,0,0,0,1.547,1.547h9.282a1.547,1.547,0,0,0,1.547-1.547V8.415Z",
    transform: "translate(-5 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumnentPlacholder);
export default __webpack_public_path__ + "static/media/documnent-placholder.183c6a7c9f11d7b1807c134154272c04.svg";
export { ForwardRef as ReactComponent };